"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var fabric_1 = require("@aperza/fabric");
var jspdf_1 = require("@aperza/jspdf");
exports.createPdf = function (pdfDoc, canvasMethodsRef) { return __awaiter(void 0, void 0, void 0, function () {
    var exportPdf, pdfCanvas, pdfCanvasContext, fabricCanvas, fabricInstance, fabricDataMap, _loop_1, existingPagesIndex;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                pdfCanvas = document.createElement('canvas');
                pdfCanvasContext = pdfCanvas.getContext('2d');
                fabricCanvas = document.createElement('canvas');
                fabricInstance = new fabric_1.fabric.StaticCanvas(fabricCanvas);
                fabricDataMap = canvasMethodsRef.current.getFabricDataMap();
                _loop_1 = function (existingPagesIndex) {
                    var pageNumber, page, viewport, exportPdfDimensions, orientation_1, renderContext, scaling, fabricMultiplier, pdfImage;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                pageNumber = canvasMethodsRef.current.getExistingPages()[existingPagesIndex];
                                return [4 /*yield*/, pdfDoc.getPage(pageNumber)];
                            case 1:
                                page = _a.sent();
                                viewport = page.getViewport({ scale: 2, rotation: 0 });
                                if (viewport.width >= 4096 || viewport.height >= 4096) { // if it's greater than 4k, no need to increase  
                                    viewport = page.getViewport({ scale: 1, rotation: 0 });
                                }
                                pdfCanvas.width = viewport.width;
                                pdfCanvas.height = viewport.height;
                                fabricInstance.setWidth(viewport.width);
                                fabricInstance.setHeight(viewport.height);
                                exportPdfDimensions = [viewport.width, viewport.height];
                                if (exportPdf) {
                                    exportPdf.addPage(exportPdfDimensions); // sets focus to this new page
                                }
                                else {
                                    orientation_1 = viewport.width > viewport.height ? 'landscape' : 'portrait';
                                    exportPdf = new jspdf_1.jsPDF({ format: exportPdfDimensions, orientation: orientation_1, unit: 'pt' }); // due to a bug in JsPdf, the orientation for the first page must be set
                                }
                                if (!exportPdf) return [3 /*break*/, 5];
                                exportPdf.setPageRotate((_a = canvasMethodsRef.current.getRotationArray()[pageNumber - 1]) !== null && _a !== void 0 ? _a : page.rotate);
                                renderContext = {
                                    canvasContext: pdfCanvasContext,
                                    viewport: viewport,
                                };
                                return [4 /*yield*/, page.render(renderContext).promise];
                            case 2:
                                _a.sent();
                                if (!fabricDataMap.fabricData[pageNumber - 1]) return [3 /*break*/, 4];
                                // if that page has markup
                                return [4 /*yield*/, new Promise(function (resolve) {
                                        return fabricInstance.loadFromJSON(fabricDataMap.fabricData[pageNumber - 1], resolve);
                                    })];
                            case 3:
                                // if that page has markup
                                _a.sent();
                                // remove shadows, kind of a work around to a fabric bug
                                fabricInstance.getObjects().forEach(function (object) {
                                    object.shadow = undefined;
                                });
                                scaling = viewport.height / fabricDataMap.fabricData[pageNumber - 1].dimensions.height;
                                fabricInstance.setZoom(scaling);
                                fabricMultiplier = 1.5;
                                pdfImage = fabricInstance.toCanvasElement(fabricMultiplier);
                                pdfCanvasContext.drawImage(pdfImage, 0, 0, viewport.width, viewport.height);
                                _a.label = 4;
                            case 4:
                                // format options: 'JPEG' | 'PNG'
                                // input is an image element, dataurl, or canvas element
                                exportPdf.addImage(pdfCanvas, 'JPEG', 0, 0, viewport.width, viewport.height); // JPEG produces smaller download than PNG but quality is the same
                                pdfCanvasContext.clearRect(0, 0, viewport.width, viewport.height);
                                _a.label = 5;
                            case 5: return [2 /*return*/];
                        }
                    });
                };
                existingPagesIndex = 0;
                _b.label = 1;
            case 1:
                if (!(existingPagesIndex < canvasMethodsRef.current.getExistingPages().length)) return [3 /*break*/, 4];
                return [5 /*yield**/, _loop_1(existingPagesIndex)];
            case 2:
                _b.sent();
                _b.label = 3;
            case 3:
                existingPagesIndex++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/, exportPdf];
        }
    });
}); };
exports.downloadPdf = function (pdfDoc, canvasMethodsRef) { return __awaiter(void 0, void 0, void 0, function () {
    var exportPdf;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, exports.createPdf(pdfDoc, canvasMethodsRef)];
            case 1:
                exportPdf = _a.sent();
                exportPdf === null || exportPdf === void 0 ? void 0 : exportPdf.save('download.pdf');
                return [2 /*return*/];
        }
    });
}); };
//# sourceMappingURL=DownloadPdf.js.map